import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './styles.less';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onlyForPrint: PropTypes.bool,
  notForPrint: PropTypes.bool,
  pageBreakBefore: PropTypes.bool,
  avoidPageBreak: PropTypes.bool,
};
const defaultProps = {
  children: null,
  className: '',
  onlyForPrint: false,
  notForPrint: false,
  pageBreakBefore: false,
  avoidPageBreak: false,
};

const PrintElement = ({
  children,
  className,
  onlyForPrint,
  notForPrint,
  pageBreakBefore,
  avoidPageBreak,
}) => (
  <div
    className={cn(s.element, className, {
      [s.noPrint]: notForPrint,
      [s.printOnly]: onlyForPrint,
      [s.pageBreakBefore]: pageBreakBefore,
      [s.avoidPageBreak]: avoidPageBreak,
    })}
  >
    {children}
  </div>
);

PrintElement.propTypes = propTypes;
PrintElement.defaultProps = defaultProps;

export default PrintElement;
